import {useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {batchPaymentService} from "../services/batchPaymentsService";
import NotificationService from "../services/NotificationService";
import notificationService from "../services/NotificationService";

const DepositSlipsPage: React.FC = () => {
    const navigate = useNavigate();
    const [depositSlipNumber, setDepositSlipNumber] = useState('');
    const [depositSlipNumberTemp, setDepositSlipNumberTemp] = useState('');
    const [customerNumber, setCustomerNumber] = useState('');
    const [whichToShow, setWhichToShow] = useState<'create' | 'search' | 'info'>('search');
    const [depositSlipInfo, setDepositSlipInfo] = useState(null)
    const errorAudioRef = useRef<HTMLAudioElement | null>(null);
    const successAudioRef = useRef<HTMLAudioElement | null>(null);
    function getDepositSlip() {
        batchPaymentService.getDepositSlip(depositSlipNumberTemp).then(r => {
            if(!r) return;
            setDepositSlipNumber(depositSlipNumberTemp)
            setDepositSlipInfo(r);
            if(r.length === 0) setWhichToShow('create')
            else setWhichToShow('info')
        })
    }
    
    function PlayErrorSound(error?: any) {
        if(error)
            NotificationService.handleError(error)
        const audio = errorAudioRef.current;
        if (audio) {
            audio.volume = 0.2;
            audio.currentTime = 0;
            audio.play().catch((err) => console.error("Audio error play failed:", err));
        }
    }

    function PlaySuccessSound() {
        const audio = successAudioRef.current;
        if (audio) {
            audio.volume = 0.2;
            audio.currentTime = 0;
            audio.play().catch((err) => console.error("Audio success play failed:", err));
        }
    }
    
    function updateWithCustomerNumber() {
        batchPaymentService.uploadDepositSlipEntry(depositSlipNumber, customerNumber, PlayErrorSound).then(r => {
            setCustomerNumber('')
            if(!r) return
            if(r.succeeded){
                PlaySuccessSound()
                getDepositSlip()
            }
            else {
                PlayErrorSound()
                notificationService.error(r.errorMessage)
            }
            
        })
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            updateWithCustomerNumber();
        }
    };
    
    function ShowDepositSlipInfo() {
        if(!depositSlipInfo) return;
        const depositSlipTotal = depositSlipInfo.reduce((sum, customer) => sum + customer.depositAmount, 0);
        return (
            <>
            <div className="container-fluid pt-160 scanPage">
                <div className="row mt-1 mb-2 pb-2 border-bottom border-light dsHeader">
                    <div className="col-md-auto">
                        <div className="d-flex align-items-center me-4">
                                <span className="viz">
                                    <i className="fa-regular fa-money-simple-from-bracket"></i>
                                </span>
                            <h2 className="">
                                <span className="headerLabel">Deposit Slip</span>
                                #{depositSlipNumber}
                            </h2>
                        </div>
                    </div>
                    <div className="col-md-auto">
                        <div className="d-flex align-items-center">
                                <span className="viz">
                                    <i className="fa-regular fa-sack-dollar"></i>
                                </span>
                            <div className="">
                                    <span className="headerLabel">
                                        Total
                                    </span>
                                <span className="headerTotal">${depositSlipTotal}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="data-Container" className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2 mt-2">
                    {depositSlipInfo.map(customer => {
                        return (
                            <div className="col">
                                <div className="transactionItem px-3 py-2 border rounded-3 bg-white"
                                     style={{cursor: 'pointer'}}
                                     onClick={() => navigate('/admin/job-details', {state: {jobId: customer.jobId, customerId: customer.customerId, customerName: customer.customerName}})}>
                                    <div className="d-flex align-items-start justify-content-between">
                                        <div className="">
                                            <span className="d-block fw-bold text-dark pe-2">{customer.customerName}</span>
                                            <span className="d-block small text-body-secondary">#{customer.customerNumber}</span>
                                        </div>
                                        <div className="">
                                            <span
                                                className="d-block fw-semibold text-end dollaDollaBills">${customer.depositAmount}</span>
                                            <span className="d-block small text-body-secondary text-end timestamp">{customer.depositSlipDate}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>)
    }

    function ShowTypeInSearch() {
        return <>
            <div className="container-fluid pt-160 scanPage">
                <div className="row mt-1 mb-2 pb-2 border-bottom border-light dsHeader">
                    <div className="col-md-auto">
                        <div className="d-flex align-items-center me-4">
                            <span className="viz">
                                <i className="fa-regular fa-money-simple-from-bracket"></i>
                            </span>
                            <h2 className="">
                                <span className="headerLabel">Deposit Slip</span>
                                <span className="headerTotal na">N/A</span>
                            </h2>
                        </div>
                    </div>
                    <div className="col-md-auto">
                        <div className="d-flex align-items-center">
                            <span className="viz">
                                <i className="fa-regular fa-sack-dollar"></i>
                            </span>
                            <div className="">
                                <span className="headerLabel">
                                    Total
                                </span>
                                <span className="headerTotal na">N/A</span>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="messageDiv">
                    <span className="thinky"><i className="fa-regular fa-circle-info"></i></span>
                    <span className="message">Scan or type a deposit slip number or customer ID</span>
                </div>
            </div>
        </>
    }

    function ShowCreateNewDepositSlip() {
        return <>
            <div className="container-fluid pt-160 scanPage">
                <div className="row mt-1 mb-2 pb-2 border-bottom border-light dsHeader">
                    <div className="col-md-auto">
                        <div className="d-flex align-items-center me-4">
                            <span className="viz">
                                <i className="fa-regular fa-money-simple-from-bracket"></i>
                            </span>
                            <h2 className="">
                                <span className="headerLabel">Deposit Slip</span>
                                #{depositSlipNumber}
                            </h2>
                        </div>

                    </div>
                    <div className="col-md-auto">
                        <div className="d-flex align-items-center">
                            <span className="viz">
                                <i className="fa-regular fa-sack-dollar"></i>
                            </span>
                            <div className="">
                                <span className="headerLabel">
                                    Total
                                </span>
                                <span className="headerTotal na">N/A</span>
                            </div>
                        </div>

                    </div>
                </div>


                <div className="messageDiv">
                    <span className="thinky"><i className="fa-solid fa-face-thinking"></i></span>
                    <span className="tldr">No deposit slip found for <span className="fw-bold">#{depositSlipNumber}</span></span>
                    <span className="message">Scan a customer ID to create a deposit slip with this number, or try typing in a different deposit slip number.</span>
                </div>
            </div>
        </>
    }

    return (
        <>
            <audio ref={errorAudioRef}>
                <source src="/audio/alarm_2.wav" type="audio/wav"/>
                Your browser does not support the audio element.
            </audio>

            <audio ref={successAudioRef}>
                <source src="/audio/cashreg.wav" type="audio/wav"/>
                Your browser does not support the audio element.
            </audio>
            <nav id="admin-header" className="admin-subheader navbar navbar-light bg-white border-top">
                <div className="row d-flex w-100 mx-3 my-2">
                    <div className="col-6">
                        <div className="input-group input-group-lg">
                            <input type="text" className="form-control" value={depositSlipNumberTemp}
                                   onChange={(e) => setDepositSlipNumberTemp(e.target.value)}
                                   placeholder="Deposit Slip #"
                                   aria-label="Deposit Slip #" aria-describedby="dsSpot"/>
                            <button onClick={getDepositSlip} className="btn btn-primary" type="button" id="dsSpot">
                                <i
                                    className="fa-regular fa-eye"></i> View
                            </button>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="input-group input-group-lg">
                            <input type="text" value={customerNumber} onKeyDown={handleKeyDown}
                                   onChange={(e) => setCustomerNumber(e.target.value)} className="form-control"
                                   placeholder="Customer ID" aria-label="Customer ID"
                                   aria-describedby="customerID"/>
                            <button onClick={updateWithCustomerNumber} className="btn btn-primary" type="button"
                                    id="customerID"><i className="fa-regular fa-plus"></i> Add
                            </button>
                        </div>
                    </div>
                </div>
            </nav>
            {whichToShow === 'search' && <>{ShowTypeInSearch()}</>}
            {whichToShow === 'create' && <>{ShowCreateNewDepositSlip()}</>}
            {whichToShow === 'info' && <>{ShowDepositSlipInfo()}</>}
        </>)
}

export default DepositSlipsPage